
import { Options, Vue } from "vue-class-component";
import Button from "./Button.vue";
import { routeChoice } from "../data/functions";
import * as data from "../data/data.json";

@Options({
  components: {
    Button,
  },
  props: {
    place: String,
    title: String,
    image: String,
    hour: String,
    link: String,
    event: Object,
  },
  methods: {
    imageValue: function (value: string) {
      const direction =
        value === "x"
          ? this.transformedImage[0]?.square.x
          : this.transformedImage[0]?.square.y;
      return typeof direction != undefined ? direction * 100 + "%" : "100%";
    },
  },
  computed: {
    styles() {
      return {
        "object-position": `${this.imageValue("x")} ${this.imageValue("y")}`,
      };
    },
  },
})
export default class ScheduleCardByHour extends Vue {
  place!: string;
  title!: string;
  image!: string;
  hour!: string;
  link!: string;
  event!: object;
  routeChoice = routeChoice;
  img =
    // @ts-ignore
    typeof this.image === "string" && this.image.slice(this.image.length - 24);
  transformedImage = data.data.transformedImages.filter((images: any) =>
    images.id.includes(this.img)
  );
}
